import React, { Component } from 'react';
import swal from 'sweetalert';
import { withNamespaces } from 'react-i18next';

const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}

class OfflineDurationSettingComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isEditable : false,
            editOfflineDuration: false,
            OfflineDurationData: {} ,
             editLifeguardPerformedCPR: false,
            LifeguardPerformedCPRData: {} ,
              editLifeguardUseDefibrillator: false,
            LifeguardUseDefibrillatorData: {} ,
            SettingValue: '',  
            editRegistrationHeader: false,
            RegistrationHeaderData: {} ,
            editRegistrationText: false,
            RegistrationTextData: {} ,
            aboutAppData : {},
            editAboutData : false,
            contactSettingData : {},
            editContactData : false,
            feedbackSettingData : {},
            editFeedbackData : false,
            supportSettingData : {},
            editSupportData : false,
            distanceLocationData: {},
            editDistance: false,
            autoApprovedUserData : {},
            editAutoApprovedUser : false,
            autoApprovedUserChecked : false,
            autoApprovedUserTimeData : {},
            autoApprovedUserTime : '',
            editAutoApprovedUserTime : false,
            setDefaultAlarmDistanceData : {},
            editDefaultAlarmDistance : false,
            setDefaultEquipmentDistanceData : '',
            equipmentDistanceData : {},
            editDefaultEquipmentDistance : false,
            autoDefaultEquipmentDistanceData : {},
            // editAutoDefaultEquipmentDistance : false,
            autoDefaultEquipmentDistanceChecked : false,
            radioEquipmentConditionData : '',
            equipmentConditionData : {},

             UpdateAbortAlarmTimeChecked : false,
            radioUpdateAbortAlarmTimeData : '',
            UpdateAbortAlarmTimeData : {},
            autoApprovedUserData1 : {},
            editAutoApprovedUser1 : false,
            autoApprovedUserChecked1 : false,
            autoApprovedUserTimeData1 : {},
            autoApprovedUserTime1 : '',
            editAutoApprovedUserTime1 : false,
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleInput = this.handleInput.bind(this);
    }
    componentDidUpdate(prevProps) { 
        if (prevProps.offlineDurationSetting != this.props.offlineDurationSetting) {
            this.props.offlineDurationSetting.allSetting.forEach(item => {
                if (item.SettingName == "OfflineStatusDuration") {
                    this.setState({
                        OfflineDurationData: item
                    })
                } 
                if (item.SettingName == "RegistrationCompleteHeader") {
                    this.setState({
                        RegistrationHeaderData: item
                    })
                } 
                if (item.SettingName == "RegistrationCompleteText") {
                    this.setState({
                        RegistrationTextData: item
                    })
                } 
                if (item.SettingName == "AboutApp") {
                    this.setState({
                        aboutAppData: item
                    })
                } 
                // if (item.SettingName == "Contact") {
                //     this.setState({
                //         contactSettingData: item
                //     })
                // } 
                if (item.SettingName == "Feedback") {
                    this.setState({
                        feedbackSettingData: item
                    })
                } 
                if (item.SettingName == "Support") {
                    this.setState({
                        supportSettingData: item
                    })
                } 
                if(item.SettingName == "DistanceForArrivedDetection") {
                    this.setState({
                        distanceLocationData : item
                    })
                }
                if(item.SettingName == "AutoApprovedUser") {
                    this.setState({
                        autoApprovedUserData : item
                    })
                }
               /*  if(item.SettingName == "SetAutoApproveUserTime") {
                    this.setState({
                        autoApprovedUserTimeData : item,
                        autoApprovedUserTime : item.SettingValue
                    })
                } */
                if(item.SettingName == "UserRegistrationRequest") {
                   
                    this.setState({
                        autoApprovedUserData1 : item
                    })
                }
                /* if(item.SettingName == "UserRegistrationRequestTime") {
                    
                    this.setState({
                        autoApprovedUserTimeData1 : item,
                        autoApprovedUserTime1 : item.SettingValue
                    })
                } */
                if(item.SettingName == "SetDefaultAlarmDistance") {
                    this.setState({
                        setDefaultAlarmDistanceData : item
                    })
                }
                if(item.SettingName == "SetDefaultEquipmentDistance") {
                    this.setState({
                        setDefaultEquipmentDistanceData : item.SettingValue,
                        equipmentDistanceData : item
                    })
                }
                if(item.SettingName == "AutoDefaultEquipmentDistance") {
                    this.setState({
                        autoDefaultEquipmentDistanceData : item
                    })
                }
                if(item.SettingName == "AbortAlarmForEquipment" || item.SettingName == "GoToPatientForEquipment") {
                    this.setState({
                        radioEquipmentConditionData : item.SettingValue,
                        equipmentConditionData : item
                    })
                }
                if(item.SettingName == "LifeguardPerformedCPR") {
                    this.setState({
                       LifeguardPerformedCPRData : item
                    })
                }
                 if(item.SettingName == "LifeguardUseDefibrillator") {
                    this.setState({
                       LifeguardUseDefibrillatorData : item
                    })
                }
                 if(item.SettingName == "ClearAbortAlarm") {
                    this.setState({
                       UpdateAbortAlarmTimeData : item
                    })
                }
            })
        }
    }
    componentWillReceiveProps(nextProps) { 
        if (nextProps.offlineDurationSetting.responseValue != this.props.offlineDurationSetting.responseValue) {
            if (nextProps.offlineDurationSetting.statusCode == 200) {
                swal(nextProps.offlineDurationSetting.message, {
                    icon: "success",
                });
                this.setState({ isEditable : false})
                this.props.getAllSettings();
            }
        }
    }
    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
        sleep(2000).then(() => { 
        })
    }
    handleInput = (event) => {
        this.setState({ radioEquipmentConditionData : event.target.value });
    }
    toggleChange = () => {
        this.setState({
            autoApprovedUserChecked: !this.state.autoApprovedUserChecked,
        });
        sleep(2000).then(() => { 
            console.log(this.state)
        })
      }
       toggleChange11 = () => {
        this.setState({
            autoApprovedUserChecked1: !this.state.autoApprovedUserChecked1,
        });
        sleep(2000).then(() => { 
            console.log(this.state)
        })
      }
      toggleChange1 = () => {
        this.setState({
            autoDefaultEquipmentDistanceChecked: !this.state.autoDefaultEquipmentDistanceChecked,
        });
        sleep(2000).then(() => { 
            console.log(this.state)
        })
      }
    editOfflineDuration = () => {
        this.setState({
            editOfflineDuration: true,
            isEditable : true,
            SettingValue: this.state.OfflineDurationData.SettingValue
        });
    };

    saveOfflineDuration = () => {
        const { t } = this.props;
        if (this.state.SettingValue && this.state.SettingValue > 0) {
            this.setState({ editOfflineDuration: false });
            this.props.updateOfflineDuration(this.state.SettingValue);
        }
        else {
            swal(`${t('General Setting.Please enter setting value and greater than 0')}`);
        }
    }
    cancelOfflineDuration = () =>{
        this.setState({editOfflineDuration : false, isEditable : false})
    }
      
      editLifeguardPerformedCPR = () => {
        this.setState({
            editLifeguardPerformedCPR: true,
            isEditable : true,
            SettingValue: this.state.LifeguardPerformedCPRData.SettingValue
        });
    };

    saveLifeguardPerformedCPR = () => {
        const { t } = this.props;
        if (this.state.SettingValue) {
            this.setState({ editLifeguardPerformedCPR: false });
            let data={
    "SettingName": "LifeguardPerformedCPR",
    "SettingValue":this.state.SettingValue
}
            this.props. UpdateLifeguardDefibrillatorCprText2(data);
        }
        else {
            swal(`Please enter Value`);
        }
    }
    cancelLifeguardPerformedCPR= () =>{
        this.setState({editLifeguardPerformedCPR : false, isEditable : false})
    }



     editUpdateAbortAlarmTime = () => {
        this.setState({
            UpdateAbortAlarmTimeChecked: true,
            isEditable : true,
            SettingValue: this.state.UpdateAbortAlarmTimeData.SettingValue
        });
    };

    saveUpdateAbortAlarmTime = () => {
        const { t } = this.props;
        if (this.state.SettingValue) {
            this.setState({ UpdateAbortAlarmTimeChecked: false });
            let data={
    "SettingName": "ClearAbortAlarm",
    "SettingValue":this.state.SettingValue
}
            this.props.UpdateAbortAlarmTimes(data);
        }
        else {
            swal(`Please enter Value`);
        }
    }
    cancelUpdateAbortAlarmTime= () =>{
        this.setState({UpdateAbortAlarmTimeChecked : false, isEditable : false})
    }
   editLifeguardUseDefibrillator = () => {
        this.setState({
            editLifeguardUseDefibrillator: true,
            isEditable : true,
            SettingValue: this.state.LifeguardUseDefibrillatorData.SettingValue
        });
    };

    saveLifeguardUseDefibrillator= () => {
        const { t } = this.props;
        if (this.state.SettingValue) {
            this.setState({ editLifeguardUseDefibrillator: false });
            let data={
    "SettingName": "LifeguardUseDefibrillator",
    "SettingValue":this.state.SettingValue
}
            this.props. UpdateLifeguardDefibrillatorCprText2(data);
        }
        else {
            swal(`Please enter Value`);
        }
    }
    cancelLifeguardUseDefibrillator= () =>{
        this.setState({editLifeguardUseDefibrillator : false, isEditable : false})
    }
    editRegistrationHeader = () => {
        this.setState({
            editRegistrationHeader: true,
            isEditable : true,
            SettingValue: this.state.RegistrationHeaderData.SettingValue
        });
    };

    saveRegistrationHeader = () => {
        const { t } = this.props;
        if (this.state.SettingValue.length > 0) {
            this.setState({ editRegistrationHeader: false });
            this.props.updateRegistrationHeader(this.state.SettingValue);
        }
        else {
            swal(`${t('General Setting.Please enter setting value')}`);
        }
    }
    cancelRegistrationHeader = () =>{
        this.setState({editRegistrationHeader : false, isEditable : false})
    }

    
    editRegistrationText = () => {
        this.setState({
            editRegistrationText: true,
            isEditable : true,
            SettingValue: this.state.RegistrationTextData.SettingValue
        });
    };

    saveRegistrationText = () => {
        const { t } = this.props;
        if (this.state.SettingValue.length > 0) {
            this.setState({ editRegistrationText: false });
            this.props.updateRegistrationText(this.state.SettingValue);
        }
        else {
            swal(`${t('General Setting.Please enter setting value')}`);
        }
    }
    cancelRegistrationText = () =>{
        this.setState({editRegistrationText : false, isEditable : false})
    }
    editAboutSetting = () =>{
        this.setState({
            editAboutData: true,
            isEditable : true,
            SettingValue: this.state.aboutAppData.SettingValue
        });
    }
    saveAboutSetting = () =>{
        const { t } = this.props;
        if (this.state.SettingValue.length > 0) {
            this.setState({ editAboutData: false });
            this.props.updateAboutSetting(this.state.SettingValue);
        }
        else {
            swal(`${t('General Setting.Please enter setting value')}`);
        }
    }
    cancelAboutSetting = () =>{
        this.setState({editAboutData : false, isEditable : false})
    }
    editContactSetting = () =>{
        this.setState({
            editContactData: true,
            isEditable : true,
            SettingValue: this.state.contactSettingData.SettingValue
        });
    }
    saveContactSetting = () =>{
        const { t } = this.props;
        if (this.state.SettingValue.length > 0) {
            this.setState({ editContactData: false });
            this.props.updateContactSetting(this.state.SettingValue);
        }
        else {
            swal(`${t('General Setting.Please enter setting value')}`);
        }
    }
    cancelContactSetting = () =>{
        this.setState({editContactData : false, isEditable : false})
    }
    editFeedbackSetting = () =>{
        this.setState({
            editFeedbackData: true,
            isEditable : true,
            SettingValue: this.state.feedbackSettingData.SettingValue
        });  
    }
    saveFeedbackSetting =() =>{
        const { t } = this.props;
        if (this.state.SettingValue.length > 0) {
            this.setState({editFeedbackData : false });
            this.props.updateFeedbackSetting(this.state.SettingValue);
        }
        else {
            swal(`${t('General Setting.Please enter setting value')}`);
        }
    }
    cancelFeedbackSetting =() =>{
        this.setState({editFeedbackData : false, isEditable : false})
    }
    editSupportSetting = () =>{
        this.setState({
            editSupportData: true,
            isEditable : true,
            SettingValue: this.state.supportSettingData.SettingValue
        });
    }
    saveSupportSetting =() =>{
        const { t } = this.props;
        if (this.state.SettingValue.length > 0) {
            this.setState({ editSupportData: false });
            this.props.updateSupportSetting(this.state.SettingValue);
        }
        else {
            swal(`${t('General Setting.Please enter setting value')}`);
        }
    }
    cancelSupportSetting =() =>{
        this.setState({editSupportData : false, isEditable : false})
    }
    editDistanceForArrivedDetection = () =>{
        this.setState({
            editDistance: true,
            isEditable : true,
            SettingValue: this.state.distanceLocationData.SettingValue
        });
    }
    saveDistanceForArrivedDetection = () =>{
        const { t } = this.props;
        if (this.state.SettingValue && this.state.SettingValue > 0) {
            this.setState({ editDistance : false });
            this.props.updateDistanceForArrivedDetection(this.state.SettingValue);
         }
         else{
            swal(`${t('General Setting.Please enter setting value and greater than 0')}`);
         }
    }
    cancelDistanceForArrivedDetection = () =>{
        this.setState({ editDistance : false,isEditable : false})
    }
    editAutoApprovedUserFunc = () => {
        this.setState({
            editAutoApprovedUser: true,
            isEditable : true,
            autoApprovedUserChecked: this.state.autoApprovedUserData.SettingValue == "True" ? true : false,
            autoApprovedUserTime : this.state.autoApprovedUserTime
        });
    }
    saveAutoApprovedUserFunc = () => {
        const { t } = this.props;
        
        if(this.state.autoApprovedUserChecked == true){
           
                this.setState({ editAutoApprovedUser : false });
                this.props.updateAutoApprovedUser('True');
               // this.props.updateAutoApprovedUserTime(this.state.autoApprovedUserTime);
              setTimeout(() => {
                this.props.getAllSettings();
      this.cancelAutoApprovedUserFunc();
    }, 1000);
            
        }
        else {
            this.props.updateAutoApprovedUser('False');
              setTimeout(() => {
                this.props.getAllSettings();
      this.cancelAutoApprovedUserFunc();
    },1000);
        }
    }
    cancelAutoApprovedUserFunc = () => {
        this.setState({ editAutoApprovedUser : false,isEditable : false})
    }
    editAutoApprovedUserTimeFunc = () => {
        this.setState({
            editAutoApprovedUserTime: true,
            isEditable : true,
            SettingValue: this.state.autoApprovedUserTimeData.SettingValue
        });
    }
    saveAutoApprovedUserTimeFunc = () => {
        const { t } = this.props;
        if (this.state.SettingValue && this.state.SettingValue > 0) {
            this.setState({ editAutoApprovedUserTime : false });
            this.props.updateAutoApprovedUserTime(this.state.SettingValue);
         }
         else{
            swal(`${t('General Setting.Please enter setting value and greater than 0')}`);
         }
    }
    cancelAutoApprovedUserTimeFunc = () => {
        this.setState({editAutoApprovedUserTime : false, isEditable : false})
    }

     editAutoApprovedUserFunc1 = () => {
        this.setState({
            editAutoApprovedUser1: true,
            isEditable : true,
            autoApprovedUserChecked1: this.state.autoApprovedUserData1.SettingValue == "True" ? true : false,
            autoApprovedUserTime1 : this.state.autoApprovedUserTime1
        });
    }
    saveAutoApprovedUserFunc1 = () => {
        const { t } = this.props;
        
        if(this.state.autoApprovedUserChecked1 == true){
           
                this.setState({ editAutoApprovedUser1 : false });
                this.props.updateAutoApprovedUser1('True');
                setTimeout(() => {
                    this.props.getAllSettings();
      this.cancelAutoApprovedUserFunc1();
    }, 1000);
                
               // this.props.updateAutoApprovedUserTime1(this.state.autoApprovedUserTime1);
            
        }
        else {
           
            this.props.updateAutoApprovedUser1('False');
            setTimeout(() => {
                this.props.getAllSettings();
      this.cancelAutoApprovedUserFunc1();
    }, 1000);
        }
    }
    cancelAutoApprovedUserFunc1 = () => {
        this.setState({ editAutoApprovedUser1 : false,isEditable : false})
    }
    editAutoApprovedUserTimeFunc1 = () => {
        this.setState({
            editAutoApprovedUserTime1: true,
            isEditable : true,
            SettingValue: this.state.autoApprovedUserTimeData1.SettingValue
        });
    }
    saveAutoApprovedUserTimeFunc1 = () => {
        const { t } = this.props;
        if (this.state.SettingValue && this.state.SettingValue > 0) {
            this.setState({ editAutoApprovedUserTime1 : false });
            this.props.updateAutoApprovedUserTime1(this.state.SettingValue);
         }
         else{
            swal(`${t('General Setting.Please enter setting value and greater than 0')}`);
         }
    }
    cancelAutoApprovedUserTimeFunc1 = () => {
        this.setState({editAutoApprovedUserTime1 : false, isEditable : false})
    }
    editDefaultAlarmDistanceFunc = () => {
        this.setState({
            editDefaultAlarmDistance: true,
            isEditable : true,
            SettingValue: this.state.setDefaultAlarmDistanceData.SettingValue
        });
    }
    saveDefaultAlarmDistanceFunc = () => {
        const { t } = this.props;
        if (this.state.SettingValue && this.state.SettingValue > 0) {
            this.setState({ editDefaultAlarmDistance : false });
            this.props.updateDefaultAlarmDistance(this.state.SettingValue);
         }
         else{
            swal(`${t('General Setting.Please enter setting value and greater than 0')}`);
         }
    }
    cancelDefaultAlarmDistanceFunc = () => {
        this.setState({editDefaultAlarmDistance : false, isEditable : false})
    }
    editDefaultEquipmentDistanceFunc = () => {
        this.setState({
            editDefaultEquipmentDistance: true,
            isEditable : true,
            setDefaultEquipmentDistanceData: this.state.setDefaultEquipmentDistanceData,
            radioEquipmentConditionData : this.state.radioEquipmentConditionData,
            autoDefaultEquipmentDistanceChecked : this.state.autoDefaultEquipmentDistanceData.SettingValue == "True" ? true : false
        });
    }
    saveDefaultEquipmentDistanceFunc = () => {
        const { t } = this.props;
        if (this.state.autoDefaultEquipmentDistanceChecked == true) {
            if(this.state.setDefaultEquipmentDistanceData && this.state.setDefaultEquipmentDistanceData > 0 
                    && this.state.radioEquipmentConditionData){
                this.props.updateAutoDefaultEquipmentDistance('True');
                this.props.updateDefaultEquipmentDistance(this.state.setDefaultEquipmentDistanceData);
                let payload;
                if(this.state.radioEquipmentConditionData == 'GoToPatient'){
                    payload = {
                        "SettingName":"GoToPatientForEquipment",
                        "SettingValue" : "GoToPatient"
                    }
                }
                else if(this.state.radioEquipmentConditionData == 'AbortAlarm') {
                    payload = {
                        "SettingName":"AbortAlarmForEquipment",
                        "SettingValue" : "AbortAlarm"
                    }
                }
                this.props.updateEquipmentCondition(payload);
            }
            else {
                swal(`${t('General Setting.Please enter setting value and greater than 0')}`);
            }
        }
        else{
            this.props.updateAutoDefaultEquipmentDistance('False');
        }
        this.setState({ editDefaultEquipmentDistance : false });
    }
    cancelDefaultEquipmentDistanceFunc = () => {
        this.setState({editDefaultEquipmentDistance : false, isEditable : false})
    }
    render() {
        const { t } = this.props;
        return (
            <div className="container">
                <div className="progressbar-heading grids-heading">
                    <h2>{t('General Setting.Update General SettingS')}</h2>
                </div>
                <div className="panel panel-widget forms-panel w3-last-form setting-layout">
                    <div className="setting-data">
                          <div className="row contact-data">
                            <div className="col-md-6">
                                {
                                    (this.state.LifeguardUseDefibrillatorData && this.state.LifeguardUseDefibrillatorData.SettingDescription) ?
                                        <p className="contact-heading">{this.state.LifeguardUseDefibrillatorData.SettingDescription}</p>
                                        : <p></p>
                                }
                                {
                                    this.state.LifeguardUseDefibrillatorData ?
                                        <p className="contact-desc">{this.state.LifeguardUseDefibrillatorData.SettingDescription}</p>
                                        : <p></p>
                                }
                            </div>
                            <div className="col-md-3">
                                {
                                    this.state.editLifeguardUseDefibrillator ?
                                        <input className="contact-input"
                                            type="text"
                                            name={'SettingValue'}
                                            value={this.state.SettingValue}
                                            onChange={this.handleChange}
                                        />
                                        :
                                        <p>{this.state.LifeguardUseDefibrillatorData.SettingValue}</p>
                                }
                                </div>
                                <div className="col-md-3">
                                {
                                    !this.state.editLifeguardUseDefibrillator ?
                                        <button type="button" className="btn btn-primary"
                                            onClick={this.editLifeguardUseDefibrillator} disabled={this.state.isEditable}>{t('Alarm Setting.Edit')}</button>
                                        :
                                        <div>
                                            <button type="button" className="btn btn-primary save-btn"
                                            onClick={this.saveLifeguardUseDefibrillator}>{t('Alarm Setting.Save')}</button>
                                            <button type="button" className="btn btn-primary"
                                            onClick={this.cancelLifeguardUseDefibrillator}>{t('Alarm Setting.Cancel')}</button>
                                        </div>
                                }
                            </div>
                        </div>
                        <div className="row contact-data">
                            <div className="col-md-6">
                                {
                                    (this.state.LifeguardPerformedCPRData && this.state.LifeguardPerformedCPRData.SettingDescription) ?
                                        <p className="contact-heading">{this.state.LifeguardPerformedCPRData.SettingDescription}</p>
                                        : <p></p>
                                }
                                {
                                    this.state.LifeguardPerformedCPRData ?
                                        <p className="contact-desc">{this.state.LifeguardPerformedCPRData.SettingDescription}</p>
                                        : <p></p>
                                }
                            </div>
                            <div className="col-md-3">
                                {
                                    this.state.editLifeguardPerformedCPR ?
                                        <input className="contact-input"
                                            type="text"
                                            name={'SettingValue'}
                                            value={this.state.SettingValue}
                                            onChange={this.handleChange}
                                        />
                                        :
                                        <p>{this.state.LifeguardPerformedCPRData.SettingValue}</p>
                                }
                                </div>
                                <div className="col-md-3">
                                {
                                    !this.state.editLifeguardPerformedCPR ?
                                        <button type="button" className="btn btn-primary"
                                            onClick={this.editLifeguardPerformedCPR} disabled={this.state.isEditable}>{t('Alarm Setting.Edit')}</button>
                                        :
                                        <div>
                                            <button type="button" className="btn btn-primary save-btn"
                                            onClick={this.saveLifeguardPerformedCPR}>{t('Alarm Setting.Save')}</button>
                                            <button type="button" className="btn btn-primary"
                                            onClick={this.cancelLifeguardPerformedCPR}>{t('Alarm Setting.Cancel')}</button>
                                        </div>
                                }
                            </div>
                        </div>
                        <div className="row contact-data">
                            <div className="col-md-6">
                                {
                                    (this.state.OfflineDurationData && this.state.OfflineDurationData.DisplayName) ?
                                        <p className="contact-heading">{this.state.OfflineDurationData.DisplayName}</p>
                                        : <p></p>
                                }
                                {
                                    this.state.OfflineDurationData ?
                                        <p className="contact-desc">{this.state.OfflineDurationData.DisplayDescription}</p>
                                        : <p></p>
                                }
                            </div>
                            <div className="col-md-3">
                                {
                                    this.state.editOfflineDuration ?
                                        <input className="contact-input"
                                            type="number"
                                            name={'SettingValue'}
                                            value={this.state.SettingValue}
                                            onChange={this.handleChange}
                                        />
                                        :
                                        <p>{this.state.OfflineDurationData.SettingValue}</p>
                                }
                                </div>
                                <div className="col-md-3">
                                {
                                    !this.state.editOfflineDuration ?
                                        <button type="button" className="btn btn-primary"
                                            onClick={this.editOfflineDuration} disabled={this.state.isEditable}>{t('Alarm Setting.Edit')}</button>
                                        :
                                        <div>
                                            <button type="button" className="btn btn-primary save-btn"
                                            onClick={this.saveOfflineDuration}>{t('Alarm Setting.Save')}</button>
                                            <button type="button" className="btn btn-primary"
                                            onClick={this.cancelOfflineDuration}>{t('Alarm Setting.Cancel')}</button>
                                        </div>
                                }
                            </div>
                        </div>
                          <div className="row contact-data">
                            <div className="col-md-6">
                                {
                                    (this.state.UpdateAbortAlarmTimeData && this.state.UpdateAbortAlarmTimeData.SettingDescription) ?
                                        <p className="contact-heading">{this.state.UpdateAbortAlarmTimeData.SettingDescription}</p>
                                        : <p></p>
                                }
                                {
                                    this.state.UpdateAbortAlarmTimeData ?
                                        <p className="contact-desc">{this.state.UpdateAbortAlarmTimeData.SettingDescription}</p>
                                        : <p></p>
                                }
                            </div>
                            <div className="col-md-3">
                                {
                                    this.state.UpdateAbortAlarmTimeChecked ?
                                        <input className="contact-input"
                                            type="text"
                                            name={'SettingValue'}
                                            value={this.state.SettingValue}
                                            onChange={this.handleChange}
                                        />
                                        :
                                        <p>{this.state.UpdateAbortAlarmTimeData.SettingValue}</p>
                                }
                                </div>
                                <div className="col-md-3">
                                {
                                    !this.state.UpdateAbortAlarmTimeChecked ?
                                        <button type="button" className="btn btn-primary"
                                            onClick={this.editUpdateAbortAlarmTime} disabled={this.state.isEditable}>{t('Alarm Setting.Edit')}</button>
                                        :
                                        <div>
                                            <button type="button" className="btn btn-primary save-btn"
                                            onClick={this.saveUpdateAbortAlarmTime}>{t('Alarm Setting.Save')}</button>
                                            <button type="button" className="btn btn-primary"
                                            onClick={this.cancelUpdateAbortAlarmTime}>{t('Alarm Setting.Cancel')}</button>
                                        </div>
                                }
                            </div>
                        </div>
                        <div className="row contact-data">
                                <div className="col-md-6">
                                {
                                    (this.state.distanceLocationData && this.state.distanceLocationData.DisplayName) ?
                                        <p className="contact-heading">{this.state.distanceLocationData.DisplayName}</p>
                                        : <p></p>
                                }
                                 {
                                    this.state.distanceLocationData ?
                                        <p className="contact-desc">{this.state.distanceLocationData.DisplayDescription}</p>
                                        : <p></p>
                                }
                                </div>
                                <div className="col-md-3">
                                {
                                    this.state.editDistance ?
                                    
                                        <input className="contact-input"
                                            type="number"
                                            name={'SettingValue'}
                                            value={this.state.SettingValue}
                                            onChange={this.handleChange}
                                        />
                                        
                                    
                                        :
                                        <p>{this.state.distanceLocationData.SettingValue}</p>
                                }
                                 </div>
                                <div className="col-md-3">
                                {
                                    !this.state.editDistance ?
                                        <button type="button" className="btn btn-primary"
                                            onClick={this.editDistanceForArrivedDetection} disabled={this.state.isEditable}>{t('Alarm Setting.Edit')}</button>
                                        :
                                        <div>
                                            <button type="button" className="btn btn-primary save-btn"
                                                onClick={this.saveDistanceForArrivedDetection}>{t('Alarm Setting.Save')}</button>
                                            <button type="button" className="btn btn-primary"
                                                onClick={this.cancelDistanceForArrivedDetection}>{t('Alarm Setting.Cancel')}</button>
                                        </div>
                                }
                                </div>
                        </div>
                        <div className="row contact-data">
                            <div className="col-md-6">
                                {
                                    (this.state.RegistrationHeaderData && this.state.RegistrationHeaderData.DisplayName) ?
                                        <p className="contact-heading">{this.state.RegistrationHeaderData.DisplayName}</p>
                                        : <p></p>
                                }
                                {
                                    this.state.RegistrationHeaderData ?
                                        <p className="contact-desc">{this.state.RegistrationHeaderData.DisplayDescription}</p>
                                        : <p></p>
                                }
                            </div>
                            <div className="col-md-3">
                                {
                                    this.state.editRegistrationHeader ?
                                        <input className="contact-input"
                                            type="text"
                                            name={'SettingValue'}
                                            value={this.state.SettingValue}
                                            onChange={this.handleChange}
                                        />
                                        :
                                        <p>{this.state.RegistrationHeaderData.SettingValue}</p>
                                }
                                </div>
                                <div className="col-md-3">
                                {
                                    !this.state.editRegistrationHeader ?
                                        <button type="button" className="btn btn-primary"
                                            onClick={this.editRegistrationHeader} disabled={this.state.isEditable}>{t('Alarm Setting.Edit')}</button>
                                        :
                                        <div>
                                            <button type="button" className="btn btn-primary save-btn"
                                            onClick={this.saveRegistrationHeader}>{t('Alarm Setting.Save')}</button>
                                            <button type="button" className="btn btn-primary"
                                            onClick={this.cancelRegistrationHeader}>{t('Alarm Setting.Cancel')}</button>
                                        </div>
                                }
                            </div>
                        </div>
                        <div className="row contact-data">
                            <div className="col-md-6">
                                {
                                    (this.state.RegistrationTextData && this.state.RegistrationTextData.DisplayName) ?
                                        <p className="contact-heading">{this.state.RegistrationTextData.DisplayName}</p>
                                        : <p></p>
                                }
                                {
                                    this.state.RegistrationTextData ?
                                        <p className="contact-desc">{this.state.RegistrationTextData.DisplayDescription}</p>
                                        : <p></p>
                                }
                            </div>
                            <div className="col-md-3">
                                {
                                    this.state.editRegistrationText ?
                                        <input className="contact-input"
                                            type="text"
                                            name={'SettingValue'}
                                            value={this.state.SettingValue}
                                            onChange={this.handleChange}
                                        />
                                        :
                                        <p>{this.state.RegistrationTextData.SettingValue}</p>
                                }
                                </div>
                                <div className="col-md-3">
                                {
                                    !this.state.editRegistrationText ?
                                        <button type="button" className="btn btn-primary"
                                            onClick={this.editRegistrationText} disabled={this.state.isEditable}>{t('Alarm Setting.Edit')}</button>
                                        :
                                        <div>
                                            <button type="button" className="btn btn-primary save-btn"
                                            onClick={this.saveRegistrationText}>{t('Alarm Setting.Save')}</button>
                                            <button type="button" className="btn btn-primary"
                                            onClick={this.cancelRegistrationText}>{t('Alarm Setting.Cancel')}</button>
                                        </div>
                                }
                            </div>
                        </div>
                        <div className="row contact-data">
                            <div className="col-md-6">
                                {
                                    (this.state.aboutAppData && this.state.aboutAppData.DisplayName) ?
                                        <p className="contact-heading">{this.state.aboutAppData.DisplayName}</p>
                                        : <p></p>
                                }
                                {
                                    this.state.aboutAppData ?
                                        <p className="contact-desc">{this.state.aboutAppData.DisplayDescription}</p>
                                        : <p></p>
                                }
                            </div>
                            <div className="col-md-3">
                                {
                                    this.state.editAboutData ?
                                        <input className="contact-input"
                                            type="text"
                                            name={'SettingValue'}
                                            value={this.state.SettingValue}
                                            onChange={this.handleChange}
                                        />
                                        :
                                        <p>{this.state.aboutAppData.SettingValue}</p>
                                }
                                </div>
                                <div className="col-md-3">
                                {
                                    !this.state.editAboutData ?
                                        <button type="button" className="btn btn-primary"
                                            onClick={this.editAboutSetting} disabled={this.state.isEditable}>{t('Alarm Setting.Edit')}</button>
                                        :
                                        <div>
                                            <button type="button" className="btn btn-primary save-btn"
                                            onClick={this.saveAboutSetting}>{t('Alarm Setting.Save')}</button>
                                            <button type="button" className="btn btn-primary"
                                            onClick={this.cancelAboutSetting}>{t('Alarm Setting.Cancel')}</button>
                                        </div>
                                }
                            </div>
                        </div>
                        {/* <div className="row contact-data">
                            <div className="col-md-6">
                                {
                                    (this.state.contactSettingData && this.state.contactSettingData.DisplayName) ?
                                        <p className="contact-heading">{this.state.contactSettingData.DisplayName}</p>
                                        : <p></p>
                                }
                                {
                                    this.state.contactSettingData ?
                                        <p className="contact-desc">{this.state.contactSettingData.DisplayDescription}</p>
                                        : <p></p>
                                }
                            </div>
                            <div className="col-md-3">
                                {
                                    this.state.editContactData ?
                                        <input className="contact-input"
                                            type="text"
                                            name={'SettingValue'}
                                            value={this.state.SettingValue}
                                            onChange={this.handleChange}
                                        />
                                        :
                                        <p>{this.state.contactSettingData.SettingValue}</p>
                                }
                                </div>
                                <div className="col-md-3">
                                {
                                    !this.state.editContactData ?
                                        <button type="button" className="btn btn-primary"
                                            onClick={this.editContactSetting} disabled={this.state.isEditable}>{t('Alarm Setting.Edit')}</button>
                                        :
                                        <div>
                                            <button type="button" className="btn btn-primary save-btn"
                                            onClick={this.saveContactSetting}>{t('Alarm Setting.Save')}</button>
                                            <button type="button" className="btn btn-primary"
                                            onClick={this.cancelContactSetting}>{t('Alarm Setting.Cancel')}</button>
                                        </div>
                                }
                            </div>
                        </div> */}
                        <div className="row contact-data">
                            <div className="col-md-6">
                                {
                                    (this.state.feedbackSettingData && this.state.feedbackSettingData.DisplayName) ?
                                        <p className="contact-heading">{this.state.feedbackSettingData.DisplayName}</p>
                                        : <p></p>
                                }
                                {
                                    this.state.feedbackSettingData ?
                                        <p className="contact-desc">{this.state.feedbackSettingData.DisplayDescription}</p>
                                        : <p></p>
                                }
                            </div>
                            <div className="col-md-3">
                                {
                                    this.state.editFeedbackData ?
                                        <input className="contact-input"
                                            type="text"
                                            name={'SettingValue'}
                                            value={this.state.SettingValue}
                                            onChange={this.handleChange}
                                        />
                                        :
                                        <p>{this.state.feedbackSettingData.SettingValue}</p>
                                }
                                </div>
                                <div className="col-md-3">
                                {
                                    !this.state.editFeedbackData ?
                                        <button type="button" className="btn btn-primary"
                                            onClick={this.editFeedbackSetting} disabled={this.state.isEditable}>{t('Alarm Setting.Edit')}</button>
                                        :
                                        <div>
                                            <button type="button" className="btn btn-primary save-btn"
                                            onClick={this.saveFeedbackSetting}>{t('Alarm Setting.Save')}</button>
                                            <button type="button" className="btn btn-primary"
                                            onClick={this.cancelFeedbackSetting}>{t('Alarm Setting.Cancel')}</button>
                                        </div>
                                }
                            </div>
                        </div>
                        <div className="row contact-data">
                            <div className="col-md-6">
                                {
                                    (this.state.supportSettingData && this.state.supportSettingData.DisplayName) ?
                                        <p className="contact-heading">{this.state.supportSettingData.DisplayName}</p>
                                        : <p></p>
                                }
                                {
                                    this.state.supportSettingData ?
                                        <p className="contact-desc">{this.state.supportSettingData.DisplayDescription}</p>
                                        : <p></p>
                                }
                            </div>
                            <div className="col-md-3">
                                {
                                    this.state.editSupportData ?
                                        <input className="contact-input"
                                            type="text"
                                            name={'SettingValue'}
                                            value={this.state.SettingValue}
                                            onChange={this.handleChange}
                                        />
                                        :
                                        <p>{this.state.supportSettingData.SettingValue}</p>
                                }
                                </div>
                                <div className="col-md-3">
                                {
                                    !this.state.editSupportData ?
                                        <button type="button" className="btn btn-primary"
                                            onClick={this.editSupportSetting} disabled={this.state.isEditable}>{t('Alarm Setting.Edit')}</button>
                                        :
                                        <div>
                                            <button type="button" className="btn btn-primary save-btn"
                                            onClick={this.saveSupportSetting}>{t('Alarm Setting.Save')}</button>
                                            <button type="button" className="btn btn-primary"
                                            onClick={this.cancelSupportSetting}>{t('Alarm Setting.Cancel')}</button>
                                        </div>
                                }
                            </div>
                        </div>
                           <div className="row contact-data">
                            <div className="col-md-6">
                                {
                                    (this.state.LifeguardUseDefibrillatorData && this.state.LifeguardUseDefibrillatorData.SettingDescription) ?
                                        <p className="contact-heading">{this.state.LifeguardUseDefibrillatorData.SettingDescription}</p>
                                        : <p></p>
                                }
                                {
                                    this.state.LifeguardUseDefibrillatorData ?
                                        <p className="contact-desc">{this.state.LifeguardUseDefibrillatorData.SettingDescription}</p>
                                        : <p></p>
                                }
                            </div>
                            <div className="col-md-3">
                                {
                                    this.state.editLifeguardUseDefibrillator ?
                                        <input className="contact-input"
                                            type="text"
                                            name={'SettingValue'}
                                            value={this.state.SettingValue}
                                            onChange={this.handleChange}
                                        />
                                        :
                                        <p>{this.state.LifeguardUseDefibrillatorData.SettingValue}</p>
                                }
                                </div>
                                <div className="col-md-3">
                                {
                                    !this.state.editLifeguardUseDefibrillator ?
                                        <button type="button" className="btn btn-primary"
                                            onClick={this.editLifeguardUseDefibrillator} disabled={this.state.isEditable}>{t('Alarm Setting.Edit')}</button>
                                        :
                                        <div>
                                            <button type="button" className="btn btn-primary save-btn"
                                            onClick={this.saveLifeguardUseDefibrillator}>{t('Alarm Setting.Save')}</button>
                                            <button type="button" className="btn btn-primary"
                                            onClick={this.cancelLifeguardUseDefibrillator}>{t('Alarm Setting.Cancel')}</button>
                                        </div>
                                }
                            </div>
                        </div>
                        <div className="row contact-data">
                            <div className="col-md-6">
                                {
                                    (this.state.LifeguardPerformedCPRData && this.state.LifeguardPerformedCPRData.SettingDescription) ?
                                        <p className="contact-heading">{this.state.LifeguardPerformedCPRData.SettingDescription}</p>
                                        : <p></p>
                                }
                                {
                                    this.state.LifeguardPerformedCPRData ?
                                        <p className="contact-desc">{this.state.LifeguardPerformedCPRData.SettingDescription}</p>
                                        : <p></p>
                                }
                            </div>
                            <div className="col-md-3">
                                {
                                    this.state.editLifeguardPerformedCPR ?
                                        <input className="contact-input"
                                            type="text"
                                            name={'SettingValue'}
                                            value={this.state.SettingValue}
                                            onChange={this.handleChange}
                                        />
                                        :
                                        <p>{this.state.LifeguardPerformedCPRData.SettingValue}</p>
                                }
                                </div>
                                <div className="col-md-3">
                                {
                                    !this.state.editLifeguardPerformedCPR ?
                                        <button type="button" className="btn btn-primary"
                                            onClick={this.editLifeguardPerformedCPR} disabled={this.state.isEditable}>{t('Alarm Setting.Edit')}</button>
                                        :
                                        <div>
                                            <button type="button" className="btn btn-primary save-btn"
                                            onClick={this.saveLifeguardPerformedCPR}>{t('Alarm Setting.Save')}</button>
                                            <button type="button" className="btn btn-primary"
                                            onClick={this.cancelLifeguardPerformedCPR}>{t('Alarm Setting.Cancel')}</button>
                                        </div>
                                }
                            </div>
                        </div>
                        <div className="row contact-data">
                            <div className="col-md-6">
                                {
                                    (this.state.autoApprovedUserData && this.state.autoApprovedUserData.DisplayName) ?
                                        <p className="contact-heading">{this.state.autoApprovedUserData.DisplayName}</p>
                                        : <p></p>
                                }
                                {
                                    this.state.autoApprovedUserData ?
                                        <p className="contact-desc">{this.state.autoApprovedUserData.DisplayDescription}</p>
                                        : <p></p>
                                }
                            </div>
                            <div className="col-md-3">
                                {
                                    this.state.editAutoApprovedUser ?
                                        // <input className="contact-input"
                                        //     type="text"
                                        //     name={'SettingValue'}
                                        //     value={this.state.SettingValue}
                                        //     onChange={this.handleChange}
                                        // />
                                        <input type="checkbox" className="delbtn" name={'SettingValue'}
                                            defaultChecked={this.state.autoApprovedUserChecked}
                                            onChange={this.toggleChange}
                                        />
                                        :
                                        <p>{this.state.autoApprovedUserData.SettingValue}</p>
                                }
                                </div>
                                <div className="col-md-3">
                                {
                                    !this.state.editAutoApprovedUser ?
                                        <button type="button" className="btn btn-primary"
                                            onClick={this.editAutoApprovedUserFunc} disabled={this.state.isEditable}>{t('Alarm Setting.Edit')}</button>
                                        :
                                        <div>
                                            <button type="button" className="btn btn-primary save-btn"
                                            onClick={this.saveAutoApprovedUserFunc}>{t('Alarm Setting.Save')}</button>
                                            <button type="button" className="btn btn-primary"
                                            onClick={this.cancelAutoApprovedUserFunc}>{t('Alarm Setting.Cancel')}</button>
                                        </div>
                                }
                            </div>
                        </div>
                           <div className="row contact-data">
                            <div className="col-md-6">
                                {
                                    (this.state.autoApprovedUserData1 && this.state.autoApprovedUserData1.DisplayName) ?
                                        <p className="contact-heading">{this.state.autoApprovedUserData1.DisplayName}</p>
                                        : <p></p>
                                }
                                {
                                    this.state.autoApprovedUserData1 ?
                                        <p className="contact-desc">{this.state.autoApprovedUserData1.DisplayDescription}</p>
                                        : <p></p>
                                }
                            </div>
                            <div className="col-md-3">
                                {
                                    this.state.editAutoApprovedUser1 ?
                                        // <input className="contact-input"
                                        //     type="text"
                                        //     name={'SettingValue'}
                                        //     value={this.state.SettingValue}
                                        //     onChange={this.handleChange}
                                        // />
                                        <input type="checkbox" className="delbtn" name={'SettingValue'}
                                            defaultChecked={this.state.autoApprovedUserChecked1}
                                            onChange={this.toggleChange11}
                                        />
                                        :
                                        <p>{this.state.autoApprovedUserData1.SettingValue}</p>
                                }
                                </div>
                                <div className="col-md-3">
                                {
                                    !this.state.editAutoApprovedUser1 ?
                                        <button type="button" className="btn btn-primary"
                                            onClick={this.editAutoApprovedUserFunc1} disabled={this.state.isEditable}>{t('Alarm Setting.Edit')}</button>
                                        :
                                        <div>
                                            <button type="button" className="btn btn-primary save-btn"
                                            onClick={this.saveAutoApprovedUserFunc1}>{t('Alarm Setting.Save')}</button>
                                            <button type="button" className="btn btn-primary"
                                            onClick={this.cancelAutoApprovedUserFunc1}>{t('Alarm Setting.Cancel')}</button>
                                        </div>
                                }
                            </div>
                        </div>
                        

                        <div className="row contact-data">
                            <div className="col-md-6">
                                {
                                    (this.state.setDefaultAlarmDistanceData && this.state.setDefaultAlarmDistanceData.DisplayName) ?
                                        <p className="contact-heading">{this.state.setDefaultAlarmDistanceData.DisplayName}</p>
                                        : <p></p>
                                }
                                {
                                    this.state.setDefaultAlarmDistanceData ?
                                        <p className="contact-desc">{this.state.setDefaultAlarmDistanceData.DisplayDescription}</p>
                                        : <p></p>
                                }
                            </div>
                            <div className="col-md-3">
                                {
                                    this.state.editDefaultAlarmDistance ?
                                        <input className="contact-input"
                                            type="number"
                                            name={'SettingValue'}
                                            value={this.state.SettingValue}
                                            onChange={this.handleChange}
                                        />
                                        :
                                        <p>{this.state.setDefaultAlarmDistanceData.SettingValue}</p>
                                }
                                </div>
                                <div className="col-md-3">
                                {
                                    !this.state.editDefaultAlarmDistance ?
                                        <button type="button" className="btn btn-primary"
                                            onClick={this.editDefaultAlarmDistanceFunc} disabled={this.state.isEditable}>{t('Alarm Setting.Edit')}</button>
                                        :
                                        <div>
                                            <button type="button" className="btn btn-primary save-btn"
                                            onClick={this.saveDefaultAlarmDistanceFunc}>{t('Alarm Setting.Save')}</button>
                                            <button type="button" className="btn btn-primary"
                                            onClick={this.cancelDefaultAlarmDistanceFunc}>{t('Alarm Setting.Cancel')}</button>
                                        </div>
                                }
                            </div>
                        </div>
                        <div className="row contact-data">
                            <div className="col-md-6">
                                {
                                    (this.state.autoDefaultEquipmentDistanceData && this.state.autoDefaultEquipmentDistanceData.DisplayName) ?
                                        <p className="contact-heading">{this.state.autoDefaultEquipmentDistanceData.DisplayName}</p>
                                        : <p></p>
                                }
                                {
                                    this.state.autoDefaultEquipmentDistanceData ?
                                        <p className="contact-desc">{this.state.autoDefaultEquipmentDistanceData.DisplayDescription}</p>
                                        : <p></p>
                                }
                            </div>
                            <div className="col-md-3">
                                {
                                    this.state.editDefaultEquipmentDistance ?
                                        // <input className="contact-input"
                                        //     type="text"
                                        //     name={'SettingValue'}
                                        //     value={this.state.SettingValue}
                                        //     onChange={this.handleChange}
                                        // />
                                        <input type="checkbox" className="delbtn" name={'SettingValue'}
                                            defaultChecked={this.state.autoDefaultEquipmentDistanceChecked}
                                            onChange={this.toggleChange1}
                                        />
                                        :
                                        <p>{this.state.autoDefaultEquipmentDistanceData.SettingValue == "True" ? 'Enable' : 'Disable'}</p>
                                }
                                 
                                </div>
                                <div className="col-md-3">
                                {
                                    !this.state.editDefaultEquipmentDistance ?
                                        <button type="button" className="btn btn-primary"
                                            onClick={this.editDefaultEquipmentDistanceFunc} disabled={this.state.isEditable}>{t('Alarm Setting.Edit')}</button>
                                        :
                                        <div>
                                            <button type="button" className="btn btn-primary save-btn"
                                            onClick={this.saveDefaultEquipmentDistanceFunc}>{t('Alarm Setting.Save')}</button>
                                            <button type="button" className="btn btn-primary"
                                            onClick={this.cancelDefaultEquipmentDistanceFunc}>{t('Alarm Setting.Cancel')}</button>
                                        </div>
                                }
                            </div>
                        </div>
                        {(this.state.editDefaultEquipmentDistance == true ? (this.state.editDefaultEquipmentDistance == true && this.state.autoDefaultEquipmentDistanceChecked == true) : this.state.autoDefaultEquipmentDistanceData.SettingValue == "True") ?
                            <div className="row contact-data">
                                <div className="col-md-6">
                                    {
                                        (this.state.equipmentDistanceData && this.state.equipmentDistanceData.DisplayName) ?
                                            <p className="contact-heading">{this.state.equipmentDistanceData.DisplayName}</p>
                                            : <p></p>
                                    }
                                    {
                                        this.state.equipmentDistanceData ?
                                            <p className="contact-desc">{this.state.equipmentDistanceData.DisplayDescription}</p>
                                            : <p></p>
                                    }
                                </div>
                                <div className="col-md-3">
                                 {
                                     (this.state.editDefaultEquipmentDistance && this.state.autoDefaultEquipmentDistanceChecked == true) ?
                                     <input className="contact-input"
                                         min="1"
                                         type="number"
                                         name={'setDefaultEquipmentDistanceData'}
                                         value={this.state.setDefaultEquipmentDistanceData}
                                         onChange={this.handleChange}
                                     />
                                         :
                                         <p>{this.state.equipmentDistanceData.SettingValue}</p>
                                 }
                                 </div>
                                 {/* <div className="col-md-3">
                                 {
                                     !this.state.editDefaultEquipmentDistance ?
                                         <button type="button" className="btn btn-primary"
                                             onClick={this.editDefaultEquipmentDistanceFunc} disabled={this.state.isEditable}>{t('Alarm Setting.Edit')}</button>
                                         :
                                         <div>
                                             <button type="button" className="btn btn-primary save-btn"
                                             onClick={this.saveDefaultEquipmentDistanceFunc}>{t('Alarm Setting.Save')}</button>
                                             <button type="button" className="btn btn-primary"
                                             onClick={this.cancelDefaultEquipmentDistanceFunc}>{t('Alarm Setting.Cancel')}</button>
                                         </div>
                                 }
                             </div> */}
                         </div>
                         : ''
                        }
                       
                        {(this.state.editDefaultEquipmentDistance == true ? (this.state.editDefaultEquipmentDistance == true && this.state.autoDefaultEquipmentDistanceChecked == true) : this.state.autoDefaultEquipmentDistanceData.SettingValue == "True") ? 
                            <div className="row contact-data">
                                <div className="col-md-6">
                                    {
                                        (this.state.equipmentConditionData && this.state.equipmentConditionData.DisplayName) ?
                                            <p className="contact-heading">Equipment Condition</p>
                                            : <p></p>
                                    }
                                    {/* {
                                        this.state.equipmentConditionData ?
                                            <p className="contact-desc">{this.state.equipmentConditionData.DisplayDescription}</p>
                                            : <p></p>
                                    } */}
                                </div>
                                <div className="col-md-3" style={{paddingLeft : '0px'}}>
                                    <label key="GoToPatient" className="checkbox-inline">
                                        <input style={{display:'inline'}}
                                            id="GoToPatient"
                                            name="EquipmentCondition"
                                            onChange={this.handleInput}
                                            value="GoToPatient"
                                            key="GoToPatient"
                                            type="radio"
                                            checked={this.state.radioEquipmentConditionData === "GoToPatient"} /> GoToPatient
                                    </label>
                                    <label style={{marginLeft:'1px !important'}} key="AbortAlarmForEquipment" className="checkbox-inline">
                                        <input style={{display:'inline',marginLeft:'1px !important'}}
                                            id="AbortAlarmForEquipment"
                                            name="EquipmentCondition"
                                            onChange={this.handleInput}
                                            value="AbortAlarm"
                                            key="AbortAlarmForEquipment"
                                            type="radio"
                                            checked={this.state.radioEquipmentConditionData === "AbortAlarm"} /> AbortAlarm
                                    </label>
                                </div>
                                {/* <div className="col-md-3">
                                {
                                    !this.state.editDefaultEquipmentDistance ?
                                        <button type="button" className="btn btn-primary"
                                            onClick={this.editDefaultEquipmentDistanceFunc} disabled={this.state.isEditable}>{t('Alarm Setting.Edit')}</button>
                                        :
                                        <div>
                                            <button type="button" className="btn btn-primary save-btn"
                                            onClick={this.saveDefaultEquipmentDistanceFunc}>{t('Alarm Setting.Save')}</button>
                                            <button type="button" className="btn btn-primary"
                                            onClick={this.cancelDefaultEquipmentDistanceFunc}>{t('Alarm Setting.Cancel')}</button>
                                        </div>
                                }
                            </div> */}
                        </div>
                        : ''
                        }
                        
                    </div>
                </div> 
            </div>
        )
    }
}
export default withNamespaces()(OfflineDurationSettingComponent);